module.exports = __webpack_public_path__ + "static/maps-section-cloud-1-25c3146a291c2c83a870d630557e1af2.png";